import { __assign } from '../../../../../../tslib/tslib.es6.js';
import { LINK, COLOR } from '../groups.js';
import { isSafeUrl, normalizeUrl } from '../../utils/url.js';

var getLinkAttrs = function (attribute) { return function (domNode) {
    var dom = domNode;
    var href = dom.getAttribute(attribute) || '';
    var attrs = {
        __confluenceMetadata: dom.hasAttribute('__confluenceMetadata')
            ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '')
            : undefined,
    };
    if (isSafeUrl(href)) {
        attrs.href = normalizeUrl(href);
    }
    else {
        return false;
    }
    return attrs;
}; };
var link = {
    excludes: LINK + " " + COLOR,
    group: LINK,
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null,
        },
    },
    inclusive: false,
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: getLinkAttrs('data-block-link'),
            contentElement: function (node) {
                var clone = node.cloneNode(true);
                clone.removeAttribute('data-block-link');
                var wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            },
        },
        {
            tag: 'a[href]',
            getAttrs: getLinkAttrs('href'),
        },
    ],
    toDOM: function (node, isInline) {
        var attrs = Object.keys(node.attrs).reduce(function (attrs, key) {
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) {
                    attrs[key] = JSON.stringify(node.attrs[key]);
                }
            }
            else if (key === 'href') {
                attrs[key] = isSafeUrl(node.attrs[key]) ? node.attrs[key] : undefined;
            }
            else {
                attrs[key] = node.attrs[key];
            }
            return attrs;
        }, {});
        if (isInline) {
            return ['a', attrs];
        }
        return [
            'a',
            __assign(__assign({}, attrs), { class: 'blockLink' }),
            0,
        ];
    },
};

export { link };



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/node_modules/@atlaskit/adf-schema/dist/esm/schema/marks/link.js